//Type
const CampaignType = {
    MANUAL: 'M',
    SEMI: 'S',
    AUTO: 'A'
};

//Execution State
const CampaignState = {
    CREATED: 0,
    FETCHED: 1,
    WAITING: 2, //MANUAL
    DIALING: 3, //SEMI
    LISTENING: 4, //AUTO
    TALKING: 5,
    PAUSED: 6
};

module.exports = {
    CampaignType,
    CampaignState
};


// WEBPACK FOOTER //
// ./src/constants.js